import { render, staticRenderFns } from "./SmsTemplateList.vue?vue&type=template&id=0fb5ecf1&scoped=true"
import script from "./SmsTemplateList.vue?vue&type=script&lang=js"
export * from "./SmsTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5ecf1",
  null
  
)

export default component.exports